/**
 * @generated SignedSource<<ec54db557e9e52876a9d4f6b35e500fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetRequest = {
  id: string;
};
export type AppQuery$variables = {
  input: GetRequest;
};
export type AppQuery$data = {
  readonly getUser: {
    readonly accessibleBrands: ReadonlyArray<{
      readonly brandFeatureFlags: ReadonlyArray<{
        readonly featureFlagId: string | null;
      }> | null;
      readonly id: string;
    }>;
    readonly featureFlags: ReadonlyArray<string> | null;
    readonly id: string;
    readonly superuser: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"CreativeDrawerUser" | "HomeUser" | "Layout_User" | "hooksUseUserRoleCheck">;
  };
};
export type AppQuery = {
  response: AppQuery$data;
  variables: AppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "superuser",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "featureFlags",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "BrandFeatureFlag",
  "kind": "LinkedField",
  "name": "brandFeatureFlags",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "featureFlagId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  (v2/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "role",
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v10 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "externalId",
    "storageKey": null
  },
  (v7/*: any*/),
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "getUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Brand",
            "kind": "LinkedField",
            "name": "accessibleBrands",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "hooksUseUserRoleCheck"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HomeUser"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreativeDrawerUser"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Layout_User"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "getUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Brand",
            "kind": "LinkedField",
            "name": "accessibleBrands",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MetaAdAccount",
                "kind": "LinkedField",
                "name": "metaAdAccounts",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availableKpis",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandConfig",
                "kind": "LinkedField",
                "name": "config",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dataGranularity",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserRole",
            "kind": "LinkedField",
            "name": "accountRoles",
            "plural": true,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserBrand",
            "kind": "LinkedField",
            "name": "userBrands",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserRole",
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Brand",
                "kind": "LinkedField",
                "name": "brand",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Brand",
                "kind": "LinkedField",
                "name": "brands",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacebookPage",
                    "kind": "LinkedField",
                    "name": "facebookPages",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InstagramAccount",
                    "kind": "LinkedField",
                    "name": "instagramAccounts",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fullName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "725cde4c0196f13ee8ec211a0c417ab2",
    "id": null,
    "metadata": {},
    "name": "AppQuery",
    "operationKind": "query",
    "text": "query AppQuery(\n  $input: GetRequest!\n) {\n  getUser(input: $input) {\n    id\n    superuser\n    featureFlags\n    accessibleBrands {\n      id\n      brandFeatureFlags {\n        featureFlagId\n      }\n    }\n    ...hooksUseUserRoleCheck\n    ...HomeUser\n    ...CreativeDrawerUser\n    ...Layout_User\n  }\n}\n\nfragment AddComment on User {\n  picture\n  fullName\n}\n\nfragment CreativeDrawerUser on User {\n  ...CreativeTextFormUser\n  ...AddComment\n}\n\nfragment CreativeTextFormUser on User {\n  account {\n    brands {\n      id\n      name\n      facebookPages {\n        id\n        externalId\n        name\n        picture\n      }\n      instagramAccounts {\n        id\n        externalId\n        name\n        picture\n      }\n    }\n  }\n}\n\nfragment HomeUser on User {\n  accessibleBrands {\n    id\n    updatedAt\n    metaAdAccounts {\n      id\n    }\n  }\n}\n\nfragment Layout_User on User {\n  id\n  ...Sidebar_User\n}\n\nfragment Sidebar_User on User {\n  id\n  firstName\n  lastName\n  email\n  picture\n  superuser\n  featureFlags\n  accessibleBrands {\n    id\n    name\n    availableKpis\n    currencyType\n    config {\n      dataGranularity\n    }\n    brandFeatureFlags {\n      featureFlagId\n    }\n  }\n  account {\n    id\n    name\n  }\n}\n\nfragment hooksUseUserRoleCheck on User {\n  superuser\n  accountRoles {\n    role\n  }\n  userBrands {\n    roles {\n      role\n    }\n    brand {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4d089cf8c9c10b905dcbe86ab69f5f57";

export default node;
